"use client";
import Buttons from "@/components/Buttons";
import image from "@/constants/image";
import { APP_ROUTES } from "@/constants/routes";
import { useUserQuery } from "@/hooks/Query/useUserQuery";
import { setUserLogin } from "@/lib/features/authSlice";
import { useAppDispatch } from "@/lib/hooks";
import { currencyTypes } from "@/models/general";
import authApiService from "@/services/main/UserServices";
import { setCookieSSR } from "@/utils/auth";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box, Menu, MenuItem, Toolbar } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import clsx from "clsx";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { memo, useEffect, useState } from "react";
import classes from "./styles.module.scss";

interface HeaderPaymentProps {
  locale?: string;
}

export const HeaderPayment = memo(function HeaderPayment({
  locale,
}: HeaderPaymentProps) {
  const queryClient = useQueryClient();
  const router = useRouter();
  const { data: user } = useUserQuery({
    options: {
      enabled: false,
    },
  });
  const isLoggedIn = !!user;
  useEffect(() => {
    if (!isLoggedIn) {
      router.replace(APP_ROUTES(locale as any).LOGIN.to);
    }
  }, [isLoggedIn, queryClient, router, locale]);
  const [anchorElCurrency, setAnchorElCurrency] = useState<null | HTMLElement>(
    null
  );

  const dispatch = useAppDispatch();

  const changeCurrency = async (currency: string) => {
    setAnchorElCurrency(null);
    setCookieSSR("currency", currency);
    if (!isLoggedIn) return;
    await authApiService.changeCurrency(currency).then(() => {
      queryClient.setQueryData(["user"], (oldData: any) => {
        return { ...oldData, currency };
      });
      dispatch(setUserLogin(user && { ...user, currency }));
    });
  };

  // const changeLanguage = async (lang: string) => {
  //   if (lang === i18n.language) return;
  //   if (isLoggedIn) {
  //     await authApiService
  //       .changeLanguage({ language: lang })
  //   }
  // };

  return (
    <header className="shadow-sm appBar bg-white sticky top-0 w-full z-[99]">
      <Toolbar className="py-2 md:!px-[84px] flex justify-between items-center">
        <Box className="h-[54px]">
          <Link
            href={APP_ROUTES(locale as any).HOME.to}
            className="cursor-pointer appbar-pay-logo-link"
          >
            <Image loading="eager" src={image.cimigoLogo2} alt="cimigoLogo" />
          </Link>
        </Box>
        <Box className={classes.groupSelect}>
          {/* <div>
              <Buttons
                className={classes.btnChangeLang}
                padding="7px 10px"
                onClick={(e) => setAnchorElLang(e.currentTarget)}
                endIcon={<KeyboardArrowDownIcon />}
              >
                <span className={classes.desktop}>
                  {langSupports?.find((it) => it.key === i18n.language)?.name}
                </span>
                <span className={classes.mobile}>
                  {langSupports?.find((it) => it.key === i18n.language)?.key}
                </span>
              </Buttons>
              <Menu
                anchorEl={anchorElLang}
                open={Boolean(anchorElLang)}
                onClose={() => setAnchorElLang(null)}
                classes={{ paper: clsx(classes.menuProfile, classes.menuLang) }}
              >
                {langSupports.map(it => (
                  <MenuItem key={it.key} onClick={() => changeLanguage(it.key)} className={clsx(classes.itemAciton, { [classes.active]: it.key === i18n.language })}>
                    <p className={classes.itName}>{it.name}</p>
                  </MenuItem>
                ))}
              </Menu>
            </div> */}
          <div>
            <Buttons
              className={classes.btnChangeLang}
              padding="7px 10px"
              onClick={(e) => setAnchorElCurrency(e.currentTarget)}
              endIcon={<KeyboardArrowDownIcon />}
            >
              <span className={classes.desktop}>
                {
                  currencyTypes?.find(
                    (it) => it.id === (user?.currency ?? "USD")
                  )?.name
                }
              </span>
              <span className={classes.mobile}>
                {
                  currencyTypes?.find(
                    (it) => it.id === (user?.currency ?? "USD")
                  )?.subName
                }
              </span>
            </Buttons>
            <Menu
              disableScrollLock={true}
              anchorEl={anchorElCurrency}
              open={Boolean(anchorElCurrency)}
              onClose={() => setAnchorElCurrency(null)}
              classes={{ paper: clsx(classes.menuProfile, classes.menuLang) }}
            >
              {currencyTypes.map((it) => (
                <MenuItem
                  key={it.id}
                  onClick={() => changeCurrency(it.id)}
                  className={clsx(classes.itemAciton, {
                    [classes.active]: it.id === (user?.currency ?? "USD"),
                  })}
                >
                  <p className={classes.itName}>{it.name}</p>
                </MenuItem>
              ))}
            </Menu>
          </div>
        </Box>
      </Toolbar>
    </header>
  );
});
